import { FC } from "react"
import { Filter, Search } from "lucide-react"
import { Input } from "./ui/input"
import { Button } from "./ui/button"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "./ui/dropdown-menu"

interface DeviceFiltersProps {
  deviceSearch: string
  setDeviceSearch: (value: string) => void
  deviceTypeFilter: string
  setDeviceTypeFilter: (value: string) => void
  deviceFilter: string
  setDeviceFilter: (value: string) => void
}

const DeviceFilters: FC<DeviceFiltersProps> = ({
  deviceSearch,
  setDeviceSearch,
  deviceTypeFilter,
  setDeviceTypeFilter,
  deviceFilter,
  setDeviceFilter,
}) => {
  return (
    <div className="flex items-center gap-4 flex-wrap">
      <div className="relative flex-1 min-w-[250px]">
        <Search className="absolute left-2 top-2.5 size-4 text-muted-foreground" />
        <Input
          placeholder="Search devices..."
          value={deviceSearch}
          onChange={(e) => setDeviceSearch(e.target.value)}
          className="pl-8"
        />
      </div>

      {/* Device Type Filters */}
      <div className="flex gap-2">
        <Button
          variant={deviceTypeFilter === "all" ? "default" : "outline"}
          size="sm"
          onClick={() => setDeviceTypeFilter("all")}
          className="animate-fade-in"
        >
          All
        </Button>
        <Button
          variant={deviceTypeFilter === "smart_meter" ? "default" : "outline"}
          size="sm"
          onClick={() => setDeviceTypeFilter("smart_meter")}
          className="animate-fade-in"
        >
          Smart Meter
        </Button>
        <Button
          variant={deviceTypeFilter === "data_logger" ? "default" : "outline"}
          size="sm"
          onClick={() => setDeviceTypeFilter("data_logger")}
          className="animate-fade-in"
        >
          Data Logger
        </Button>
        <Button
          variant={deviceTypeFilter === "unknown" ? "default" : "outline"}
          size="sm"
          onClick={() => setDeviceTypeFilter("unknown")}
          className="animate-fade-in"
        >
          Unknown
        </Button>
      </div>

      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="outline" size="sm" className="gap-2">
            <Filter className="size-4" />
            {deviceFilter === "all" ? "All" : deviceFilter === "alarms" ? "With Alarms" : "Without Alarms"}
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent>
          <DropdownMenuItem onClick={() => setDeviceFilter("all")}>All</DropdownMenuItem>
          <DropdownMenuItem onClick={() => setDeviceFilter("alarms")}>
            With Alarms
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => setDeviceFilter("normal")}>
            Without Alarms
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  )
}

export default DeviceFilters
